import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { IoChevronBackCircleOutline } from "react-icons/io5";
import instance, { lienFacture } from "../../api/api";

import { Galleria } from "primereact/galleria";
// import { Button } from "primereact/button";
import { Help } from "../../utils";
import { InfoDetails, ModalDelete } from "../../shared/compoments";
import DescriptionIcon from "@mui/icons-material/Description";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { useSelector, useDispatch } from "react-redux";
// import { toogleGalerie } from "../../store/slice/GalerieContrat";
import { Header, LoadingSpinner } from "../../shared/compoments";
import { showModal } from "../../store/slice/PrintSlice";
import { GiTakeMyMoney } from "react-icons/gi";
// import { Document, Page } from 'react-pdf';
// import { Card, CardMedia, CardContent, Typography } from '@mui/material';
function ContratDetail() {
  const galleria = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const seeGalerie = useSelector((state) => state.galerie.isSeeGalerie);
  const [detailContrat, setDetailContrat] = useState({});
  const [detailInfo, setDetailInfo] = useState([]);
  const DATA_BTN_WITH_CONTRAT_OPTIONS = [
    {
      titleBtn: "Voir le contrat",
      icone: <DescriptionIcon />,
      isColor: false,
      isVisible: true,
      methode: () => {
        console.log("Voir le contrat25");
        // dispatch(toogleGalerie());
        galleria.current.show();
      },
    },
    {
      titleBtn: "Voir les factures",
      icone: <FileCopyIcon />,
      isVisible: true,
      methode: () => {
        navigate("/Contrats/detail-factures/" + detailContrat.client_id);
        // navigate(`/contrats/${detailContrat?.id}/factures`)
      },
    },
    {
      titleBtn: "Commissions",
      icone: <GiTakeMyMoney />,
      isVisible: true,
      methode: () => {
        dispatch(showModal());
      },
    },
  ];

  const dataInfoDetail = (
    created_at,
    reference,
    nombre_mois_caution,
    nombre_mois_avance,
    nom,
    nombre_pieces,
    cost,
    creator,
    commission_montant_aprimmo,
    project_percentage
  ) => {
    const element = [];
    element.push(
      { title: "DATE D'ENREGISTREMENT", value: Help.convertDate(created_at) },
      { title: "RÉFÉRENCE", value: reference },
      { title: "COMMERCIAL", value: `${creator.nom} ${creator.prenom}` },
      {
        title: "COMMISSION APPRIMMO",
        value: `${commission_montant_aprimmo} (${project_percentage}%)`,
      },

      { title: "PROPRIÉTÉ", value: nom },
      {
        title: "PRIX DE LA PROPRIÉTÉ (FCFA)",
        value: Help.convertInMoney(cost),
      },
      {
        title: "CAUTION (Mois)",
        value: nombre_mois_caution ? `${nombre_mois_caution}` : "Néant",
      },
      {
        title: "AVANCE (Mois)",
        value: nombre_mois_avance ? `${nombre_mois_avance}` : "Néant",
      },
      { title: "NOMBRE DE PIÈCE", value: String(nombre_pieces) }
    );
    setDetailInfo(element);
    console.log("detailInfo85", detailInfo);
  };
  useEffect(() => {
    const getReservationContrat = async () => {
      try {
        const response = await instance.get(`/contracts/${id}`);
        console.log("etReservationContrat25", response);
        const {
          created_at,
          reference,
          nombre_mois_caution,
          nombre_mois_avance,
          propriety: { nom, nombre_pieces, cost },
          creator,
          commission_montant_aprimmo,
          project_percentage,
        } = response.data.data;
        dataInfoDetail(
          created_at,
          reference,
          nombre_mois_caution,
          nombre_mois_avance,
          nom,
          nombre_pieces,
          cost,
          creator,
          commission_montant_aprimmo,
          project_percentage
        );
        setDetailContrat(response.data.data);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
      }
    };
    getReservationContrat();
  }, [id]);
  const itemTemplate = (item) => {
    return (
      <img
        src={lienFacture + item.path}
        alt={item.alt}
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={item.thumbnailImageSrc}
        alt={item.alt}
        style={{ display: "block" }}
      />
    );
  };

  if (!detailContrat?.created_at) return <LoadingSpinner />;

  return (
    <>
      <ModalDelete
        commissionVente
        infoAllCommissions={[
          {
            libelle: "Partenaire",
            value: detailContrat.commission_apporteur_structure,
          },
          {
            libelle: "Apporteur d'affaire",
            value: detailContrat.commission_montant_introducteur,
          },
          {
            libelle: "Apprimmo",
            value: detailContrat.commission_montant_aprimmo,
          },
          {
            libelle: "Apprimmo en fonction de la superficie",
            value: detailContrat.commission_apporteur_structure,
          },
        ]}
        modalTitle={"Commissions"}
        isPrintFacture={false}
        isRejectedBtn={false}
        dataInfoForBtn={[]}
      />
      <Header libelle={"Détails Contrat"} isReturn />
      {
        <Galleria
          ref={galleria}
          value={detailContrat?.photos}
          numVisible={9}
          style={{ maxWidth: "50%" }}
          circular
          fullScreen
          showItemNavigators
          showThumbnails={false}
          item={itemTemplate}
          thumbnail={thumbnailTemplate}
        />
      }
      <InfoDetails
        namePerson={`${detailContrat?.client?.nom} ${detailContrat?.client?.prenom}`}
        detailPhone={detailContrat?.client?.phone}
        detailAdresse={detailContrat?.client?.adresse}
        detailEmail={detailContrat?.client?.email}
        titleInfo={"Information du contrat"}
        widthBody={"45%"}
        dataInfo={detailInfo}
        dataBtnWithOptions={DATA_BTN_WITH_CONTRAT_OPTIONS}
      />
    </>
    // <div className="detail-student">
    //   <Galleria
    //     ref={galleria}
    //     value={detailContrat?.photos}
    //     numVisible={9}
    //     style={{ maxWidth: "50%" }}
    //     circular
    //     fullScreen
    //     showItemNavigators
    //     showThumbnails={false}
    //     item={itemTemplate}
    //     thumbnail={thumbnailTemplate}
    //   />

    //   <div className="back-user">
    //     <IoChevronBackCircleOutline
    //       className="back-home"
    //       onClick={() => {
    //         navigate(-1);
    //       }}
    //     />

    //     <h5>
    //       <span className="text-primary">Contrat</span> /{" "}
    //       <span className="text-primary">Détail</span>
    //     </h5>
    //   </div>
    //   <div className="conteneur_info_personnelle d-flex align-items-center gap-3 flex-wrap">
    //     <img src="" alt="image_perso" />
    //     <div className="personnelle_information p-3">
    //       <h1>
    //         {detailContrat?.client?.nom} {detailContrat?.client?.prenom}
    //       </h1>
    //       <div
    //         className="d-flex gap-3 align-items-center flex-wrap py-2"
    //         style={{ borderTop: "0.5px solid gray", flex: 1 }}
    //       >
    //         <p>
    //           <span className="fw-bold text-secondary">Email :</span>{" "}
    //           <span>{detailContrat?.client?.email}</span>
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">Contact :</span>{" "}
    //           <span>{detailContrat?.client?.phone}</span>
    //         </p>
    //       </div>
    //     </div>
    //   </div>

    //   <div className="conteneur_contrat">
    //     <div className="contrat">
    //       <span className="badge bg-info">Information du contrat</span>
    //     </div>
    //     <div className="d-flex justify-content-between gap-3">
    //       <div>
    //         <p>
    //           <span className="fw-bold text-secondary">
    //             Date d'Enregistrement :
    //           </span>{" "}
    //           <br />
    //           <span>
    //             {new Date(detailContrat?.created_at).toLocaleDateString("fr")}
    //           </span>
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">
    //             Référence :
    //           </span>{" "}
    //           <br />
    //           <span>
    //             {detailContrat?.reference}
    //           </span>
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">Caution :</span> <br />
    //           <span>
    //             {detailContrat?.nombre_mois_caution} ({""}
    //             {Number(detailContrat?.nombre_mois_caution) *
    //               Number(detailContrat?.propriety.cost)}{" "}
    //             Fcfa)
    //           </span>
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">Avance :</span> <br />
    //           <span>
    //             {detailContrat?.nombre_mois_avance} ({""}
    //             {Number(detailContrat?.nombre_mois_avance) *
    //               Number(detailContrat?.propriety.cost)}{" "}
    //             Fcfa)
    //           </span>
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">Propriété :</span> <br />
    //           <span> {detailContrat?.propriety.nom} </span>
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">Nombre de pièce :</span>{" "}
    //           <br />
    //           <span> {detailContrat?.propriety.nombre_pieces} </span>
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">Rédacteur du contrat :</span>{" "}
    //           <br />
    //           <span> {detailContrat?.creator.nom} </span>
    //           <span> {detailContrat?.creator.prenom} </span>
    //         </p>
    //         <button className="btn bg-primary text-light"
    //         onClick={()=>navigate(`/contrats/${detailContrat?.id}/factures`)}
    //         >Voir les factures</button>
    //       </div>
    //       <div>
    //         {
    //           detailContrat?.photos.length > 0 &&
    //           <Button label="Voir le contrat"
    //        icon="pi pi-external-link"
    //       severity="secondary"
    //       size="small"
    //       onClick={() => galleria.current.show()} />
    //         }

    //       </div>
    //     </div>
    //   </div>
    //   {/* <div>
    //     <p>
    //       <span className="fw-bold text-secondary">Statut :</span>{" "}
    //       <span
    //       >
    //         {detailContrat?.status}
    //       </span>
    //     </p>
    //     <p>
    //       <span className="fw-bold text-secondary">Date de Contrat :</span>{" "}
    //       {new Date(detailContrat?.created_at).toLocaleDateString("fr")}{" "}
    //     </p>
    //     <p>
    //       <span className="fw-bold text-secondary">Contrat pour le :</span>{" "}
    //       {detailContrat?.date} à {detailContrat?.heure}
    //     </p>
    //     <p>
    //       <span className="fw-bold text-secondary">Montant :</span>{" "}
    //       {detailContrat?.montant} Fcfa
    //     </p>
    //     <p>
    //       <span className="fw-bold text-secondary">Service :</span>{" "}
    //       {detailContrat?.service.libelle}
    //     </p>
    //     {detailContrat?.commentaire && (
    //       <p>
    //         <span className="fw-bold text-secondary">Commentaire :</span>{" "}
    //         {detailContrat?.commentaire}
    //       </p>
    //     )}

    //     <span className="badge bg-info">Info client</span>
    //     <p>
    //       <span className="fw-bold text-secondary"> Client :</span>{" "}
    //       {detailContrat?.user.nom} {detailContrat?.user.prenom}
    //     </p>
    //     <p>
    //       <span className="fw-bold text-secondary">Email :</span>{" "}
    //       {detailContrat?.user.email}
    //     </p>
    //     <p>
    //       <span className="fw-bold text-secondary">Téléphone :</span>{" "}
    //       {detailContrat?.user.phone}
    //     </p>
    //     {detailContrat?.date_debut && detailContrat?.date_fin && (
    //       <>
    //         <span className="badge bg-warning">Info opérateur</span>
    //         <p>
    //           <span className="fw-bold text-secondary">Heure de début :</span>{" "}
    //           {detailContrat?.date_debut}
    //         </p>
    //         <p>
    //           <span className="fw-bold text-secondary">Heure de fin :</span>{" "}
    //           {detailContrat?.date_fin}
    //         </p>
    //       </>
    //     )}
    //   </div> */}
    //   {/* <div className="text-center">
    //     <button className="btn bg-primary text-light mx-3"
    //     onClick={() =>{
    //       setRejet(false)
    //       setVisible(true)
    //     } }
    //     >Accepter</button>
    //     <button className="btn bg-danger text-light"
    //     onClick={() => {
    //       setRejet(true)
    //       setVisible(true)
    //     }}
    //     >Rejeter</button>
    //   </div> */}
    // </div>
  );
}

export default ContratDetail;
